import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RtIconComponent } from './components/rt-icon/rt-icon.component';

import { RtSvgSpriteComponent } from './rt-svg-sprite.component';

@NgModule({
  declarations: [RtSvgSpriteComponent, RtIconComponent],
  exports: [RtSvgSpriteComponent, RtIconComponent],
  imports: [CommonModule]
})
export class RtSvgSpriteModule {
}
